/**
 * @property process.env.MIX_GOOGLEMAPS_API_KEY
 * @property process.env.MIX_BUCKET_NAME
 * @property process.env.MIX_APP_URL
 * @property process.env.MIX_CDN_URL
 * @property process.env.MIX_CDN_IMAGES_URL
 * @namespace process
 * */

const APP_URL = process.env.MIX_APP_URL;
const GOOGLEMAPS_API_KEY = process.env.MIX_GOOGLEMAPS_API_KEY;
const NAME_TO_SLUG_UPDATE = 'update-slug-to-name';
const DATE_TIME_SEQUENCER_UPDATE = 'update-date_time_sequencer';
const DATE_TIME_SEQUENCER_ENABLE = 'update-date_time_enable';
const CDN_URL = process.env.MIX_CDN_URL;

const BUCKET_NAME = process.env.MIX_BUCKET_NAME;
const Vue = require('vue');
const HUB = new Vue();
const BOOKMARKS_COMMUNICATIONS = new Vue({});

const BREAKPOINT = {
	current: function () {
		let breakpoints = document
			.getElementById('media-break-points')
			.querySelectorAll('.break-point');

		for (let i = 0; i < breakpoints.length; ++i) {
			let test = getComputedStyle(breakpoints[i]).display;
			if (test == 'block') {
				return breakpoints[i].getAttribute('data-break-point');
			}

		}
	}
};

const IMAGE_URL_BASE = {
	default_url: process.env.MIX_CDN_IMAGES_URL,
	uploads_url: process.env.MIX_CDN_IMAGES_URL + 'uploads/',
	events_url: process.env.MIX_CDN_IMAGES_URL + 'events/',
	teams_url: process.env.MIX_CDN_IMAGES_URL + 'teams/',
	entities_url: process.env.MIX_CDN_IMAGES_URL + 'entities/',
};

export {
	BREAKPOINT,
	BOOKMARKS_COMMUNICATIONS,
	APP_URL,
	GOOGLEMAPS_API_KEY,
	NAME_TO_SLUG_UPDATE,
	DATE_TIME_SEQUENCER_UPDATE,
	DATE_TIME_SEQUENCER_ENABLE,
	HUB,
	CDN_URL,
	BUCKET_NAME,
	IMAGE_URL_BASE
}



// WEBPACK FOOTER //
// ./resources/assets/js/config.js